export const events = {
	init: () => {
		initCatFilter();
	},
};

function initCatFilter() {
	const catFilterField = document.querySelector( 'form.events-filter #events-filter-category' );
	if ( !catFilterField ) {
		return;
	}
	catFilterField.addEventListener( 'change', ( event ) => {
		const selectedCatId = event.target.value;
		const url = new URL( window.location.href );
		if ( selectedCatId ) {
			url.search = '?cat=' + selectedCatId;
		} else {
			url.search = '';
		}

		window.history.pushState( { path: url.toString() }, '', url );
		window.location.reload();
	} );
}
